import { useEffect, useState } from "react";
import { Phone, CalendarCheck } from "lucide-react";
import { BUSINESS } from "@/lib/business-info";

export default function MobileStickyCTA() {
    const [show, setShow] = useState(false);

    useEffect(() => {
        const onScroll = () => setShow(window.scrollY > 320);
        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    const scrollToInquiry = (type) => {
        const el = document.getElementById("catering-inquiry");
        if (el) {
            el.scrollIntoView({ behavior: "smooth", block: "start" });
            const detail = new CustomEvent("set-inquiry-type", { detail: type });
            window.dispatchEvent(detail);
        }
    };

    return (
        <div
            data-testid="mobile-sticky-cta"
            className={`md:hidden fixed bottom-0 inset-x-0 z-[10000] transition-transform duration-500 ${
                show ? "translate-y-0" : "translate-y-full"
            }`}
        >
            <div className="bg-charcoal/95 backdrop-blur-md border-t border-cream/10 px-4 py-3 grid grid-cols-2 gap-3 shadow-[0_-20px_50px_rgba(0,0,0,0.5)]">
                <a
                    href={BUSINESS.phoneLink}
                    data-testid="mobile-sticky-call"
                    className="empire-btn-secondary !py-3 !text-[11px] !px-2"
                >
                    <Phone size={14} />
                    Call
                </a>
                <button
                    type="button"
                    onClick={() => scrollToInquiry("catering")}
                    data-testid="mobile-sticky-catering"
                    className="empire-btn-primary !py-3 !text-[11px] !px-2"
                >
                    <CalendarCheck size={14} />
                    Book Catering
                </button>
            </div>
        </div>
    );
}
